import React from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardUtilizador from "components/CardUtilizador";

import withStyles from "@material-ui/core/styles/withStyles";
import formacoesStyle from "assets/jss/material-dashboard-pro-react/views/formacoesStyle.jsx";
import {faFileDownload} from "@fortawesome/free-solid-svg-icons";
import Button from "../../../components/CustomButtons/Button";
import MomentFromNow from "../../../components/MomentFromNow";
import Parser from "html-react-parser";
import connection from "../../../connection";
import SweetAlert from "../../../components/SweetAlertWrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip";
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";
import {primaryColor} from "../../../assets/jss/material-dashboard-pro-react";
import {fases} from "./fases";

import PreencherFeedback from "views/Pages/PreencherFeedback.jsx";
import ConfirmarRegisto from "../../../components/ConfirmarRegisto/ConfirmarRegisto";

const FormacaoMap = withScriptjs(
  withGoogleMap(props => {
    return <GoogleMap
      defaultZoom={16}
      defaultCenter={{lat: props.lat, lng: props.lon}}
      defaultOptions={{
        disableDefaultUI: true
      }}
      center={{lat: props.lat, lng: props.lon}}
    >
      <Marker position={{lat: props.lat, lng: props.lon}}/>
    </GoogleMap>
  })
);

class VisualizacaoFormacao extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formacao: props.detalhes,
      posts: [],
      modal: null,
      aceitar_termos_condicoes: false,
    };

    this.hideModal = this.hideModal.bind(this);

    this.reloadPostsFormacao = async () => {
      let posts = await connection.get("formacao/post/listagem", {id_formacao: this.state.formacao.id});

      this.setState({posts})
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {formacao: props.detalhes};
  }

  componentDidMount() {
    this.reloadPostsFormacao();
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }

  render() {
    const {classes, location} = this.props;
    const {formacao} = this.state;

    let preco = formacao.preco_inscricao.toFixed(2).replace(".", ",") + "€";

    return <div className={classes.cursosContainer}>
      <div className={classes.eventLabel}>
        <p>Módulo</p>
        <h2>{formacao.modulo.codigo + " | " + formacao.modulo.designacao}</h2>
        {formacao.registo.estado_participacao && formacao.registo.estado_participacao.code > 0 && <div style={{textAlign: "center", margin: "11px 0px 8px"}}>
                <span style={{borderColor: formacao.registo.estado_participacao.color, borderWidth: 2, borderStyle: "solid", borderRadius: 4, padding: "4px 10px", fontWeight: 400, color: "#656565", textTransform: "uppercase"}}>
                {formacao.registo.estado_participacao.designation}
                </span>
        </div>}
      </div>
      {fases(formacao)}
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12} sm={8}>
          {this.state.formacao.registo.presenca && !this.state.formacao.registo.feedback_enviado && this.state.formacao.registo.resultado === 0 && <div className={classes.warningLabel}>
            <span className="">Atenção: por favor responda ao formulário de feedback do módulo.</span>
          </div>}
          {formacao.local && <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1, marginBottom: 0}}>Localização</h4>
              <p>{formacao.local}</p>
            </CardHeader>
            <FormacaoMap
              googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + process.env.MAPS_KEY + "&basemap=roadmap"}
              loadingElement={<div style={{height: `100%`}}/>}
              lat={formacao.lat}
              lon={formacao.lon}
              containerElement={
                <div
                  style={{
                    height: "288px",
                    borderRadiusBottomRight: "6px",
                    borderRadiusBottomLeft: "6px",
                    overflow: "hidden"
                  }}
                />
              }
              mapElement={<div style={{height: `100%`}}/>}
            />
          </Card>}
          {(formacao.modulo.ficha || formacao.modulo.documento_ficha) && <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>
                Ficha do Módulo {formacao.modulo.documento_ficha && <Tooltip
                title="Descarregar ficha"
                placement="top"
                classes={{tooltip: classes.tooltip}}
              >
                <a target="_blank" rel="noopener noreferrer" href={connection.getFullUrl(formacao.modulo.documento_ficha.path)}> <FontAwesomeIcon color={primaryColor} icon={faFileDownload}/></a>
              </Tooltip>}
              </h4>
            </CardHeader>
            {!formacao.modulo.documento_ficha && formacao.modulo.ficha && <CardBody className={classes.courseDetails}>
              <p>{Parser(formacao.modulo.ficha.trim().split("\n").join("<br/>"))}</p>
            </CardBody>}
            {formacao.modulo.documento_ficha && <div>
              {formacao.modulo.documento_ficha.informacoes_ficheiro.mimetype.substr(0, 5) === 'image' ? <img width="100%" src={connection.getFullUrl(formacao.modulo.documento_ficha.path)}/> :
                <div style={{paddingBottom: "141%", position: "relative"}}>
                  <iframe width="100%" style={{border: 0, position: "absolute", top: 0, bottom: 0, left: 0, right: 0, height: "100%"}} src={connection.getFullUrl(formacao.modulo.documento_ficha.path) + "#toolbar=0&view=Fit&navpanes=0"}/>
                </div>}
            </div>}
          </Card>}
          {this.state.posts && this.state.posts.length > 0 && <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Anúncios</h4>
            </CardHeader>
            {this.state.posts.map((post, idx) => {
              return <React.Fragment><CardBody>
                <p style={{marginBottom: 4}}><strong>{post.titulo}</strong></p>
                {Parser(post.conteudo.trim().split("\n").join("<br/>"))}
                <p style={{textAlign: "right", margin: 0, fontSize: 12}}><MomentFromNow time={post.data}/></p>
                {(idx < this.state.posts.length - 1) && <hr style={{marginBottom: 0}}/>}
              </CardBody>
              </React.Fragment>;
            })}
          </Card>}
        </GridItem>
        <GridItem xs={12} sm={4}>
          {(formacao.registo.presenca && !formacao.registo.feedback_enviado && this.state.formacao.registo.resultado === 0) ? <Card style={{marginBottom: 0}}>
            <CardBody className={classes.courseDetails}>
              <h5>A sua presença foi registada. Por favor preencha o formulário de feedback.</h5>
              <Button className={classes.button + " " + classes.info + " " + classes.block} size="sm" onClick={() => {
                this.setState({
                  modal: (<SweetAlert
                    style={{
                      width: 750, padding: 40
                    }}
                    title="Feedback do módulo"
                    showCancel={false}
                    showConfirm={false}
                    onConfirm={() => {
                    }}
                    onCancel={this.hideModal}
                    showClose
                  >
                    <PreencherFeedback formacaoId={formacao.id} modalidade={formacao.modalidade} onFeedbackGiven={() => {
                      this.hideModal();
                      this.props.reloadDetalhes();
                    }}/>
                  </SweetAlert>)
                })
              }}> Enviar Feedback
              </Button>
            </CardBody>
          </Card> : null}
          <CardUtilizador compact utilizador={formacao.formador} label={"Formador"} pode_ver_utilizador={formacao.formador.pode_ver_formador}/>
          <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Informações</h4>
            </CardHeader>
            <CardBody className={classes.courseDetails}>
              <GridContainer>
                <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{formacao.modalidade_designacao}</h4>
                    <p>Modalidade</p>
                  </div>
                </GridItem>
                {formacao.agrupamento && <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{formacao.agrupamento}</h4>
                    <p>Agrupamento</p>
                  </div>
                </GridItem>}
                {formacao.nucleo && <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{formacao.nucleo}</h4>
                    <p>Núcleo</p>
                  </div>
                </GridItem>}
                {formacao.regiao && <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{formacao.regiao}</h4>
                    <p>Região</p>
                  </div>
                </GridItem>}
                <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{formacao.vagas_livres}</h4>
                    <p>Vagas</p>
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <div className={classes.itemDetalhes}>
                    <h4>{formacao.preco_inscricao !== null ? (formacao.preco_inscricao.toFixed(2).replace(".", ",") + "€") : "Por definir"}</h4>
                    <p>Preço</p>
                  </div>
                </GridItem>
                {formacao.descricao_longa && <GridItem xs={12} sm={12}>
                  <div className={classes.outrosDetalhes}>
                    <h4>Outras informações</h4>
                    <p>{formacao.descricao_longa}</p>
                  </div>
                </GridItem>}
              </GridContainer>
            </CardBody>
          </Card>
          {!formacao.data_formacao_anulada && <ConfirmarRegisto acontecimento={formacao} designacao={`módulo ${formacao.modulo.codigo} | ${formacao.modulo.designacao}`} dados={{formacao: formacao.id, preco: formacao.preco_inscricao, aceitacao: false}} reloadDetalhes={this.props.reloadDetalhes}/>}
        </GridItem>
      </GridContainer>
    </div>;
  }
}

export default withStyles(formacoesStyle)(VisualizacaoFormacao);
